<template>
  <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
    <!-- search condition start -->
    <el-row class="flex">
      <el-input
        v-model="searchCondition.keyword"
        clearable
        size="small"
        :placeholder="$t('名称描述')"
        class="w-200px mr-10px"
      ></el-input>
      <el-select
        class="w-200px mr-10px"
        v-model="searchCondition.type"
        filterable
        allow-create
        clearable
        size="small"
      >
        <el-option
          v-for="item in apiTypes"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-select
        class="w-200px mr-10px"
        size="small"
        clearable
        v-model="searchCondition.audit_state"
        :placeholder="$t('请选择状态')"
      >
        <el-option
          :label="item.label"
          :value="item.value"
          v-for="(item, index) in auditStutusList"
          :key="index"
        ></el-option>
      </el-select>
      <el-input
        v-model="searchCondition.name"
        clearable
        size="small"
        placeholder="应用"
        class="w-200px mr-10px"
      ></el-input>
      <el-input
        class="w-200px mr-10px"
        v-model="searchCondition.department_id"
        clearable
        size="small"
        placeholder="部门"
      ></el-input>
      <el-button type="primary" @click="searchTableData()">{{ $t('search') }}</el-button>
      <el-button
        :disabled="!$hasAccess('apply')"
        type="primary"
        @click="$router.push('./api-apply')"
        >申请</el-button
      >
      <el-button
        :disabled="!$hasAccess('submit') || selectList.length === 0"
        type="primary"
        @click="submit"
        :loading="submitLoading"
        >提交</el-button
      >
      <el-button
        :disabled="!$hasAccess('withdraw') || selectList.length === 0"
        type="primary"
        @click="withdraw"
        :loading="withdrawLoading"
        >撤回</el-button
      >
    </el-row>
    <!-- search condition end -->
    <!-- table start -->
    <el-table
      :data="tableData"
      class="mt-20px"
      border
      height="calc(100% - 106px)"
      v-loading="tableLoading"
      row-key="applyOpenApiRecordId"
      @selection-change="selectionChange"
      ref="table"
    >
      <el-table-column type="selection" :reserve-selection="true" width="55"></el-table-column>
      <el-table-column
        :label="$t('名称')"
        prop="openApiName"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        :label="$t('类型')"
        prop="openApiType"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        :label="$t('描述')"
        prop="openApiDescription"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        :label="$t('申请应用')"
        prop="applyApplicationName"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column :label="$t('申请部门')" prop="applyDepartment" show-overflow-tooltip>
      </el-table-column>
      <el-table-column :label="$t('状态')" width="120" prop="auditStatusName" show-overflow-tooltip>
      </el-table-column>
      <el-table-column :label="$t('操作')" width="320">
        <template slot-scope="scope">
          <el-button
            :disabled="!$hasAccess('submit') || scope.row.auditStatus !== 1"
            size="mini"
            @click="handleRow(scope.row, 'submit')"
            >提交</el-button
          >
          <el-button
            :disabled="!$hasAccess('withdraw') || scope.row.auditStatus !== 2"
            size="mini"
            @click="handleRow(scope.row, 'reset')"
            >撤回</el-button
          >
          <el-button
            :disabled="!$hasAccess('update') || scope.row.auditStatus !== 1"
            size="mini"
            @click="handleRow(scope.row, 'edit')"
            >编辑</el-button
          >
          <el-button
            size="mini"
            @click="handleRow(scope.row, 'read')"
            :disabled="!$hasAccess('read')"
            >查看</el-button
          >
          <el-button :disabled="!$hasAccess('delete')" size="mini" @click="deleteRow(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- table end -->
    <!-- pagigation start -->
    <el-pagination
      class="mt-20px float-right"
      background
      @size-change="searchTableData()"
      @current-change="findTableData()"
      :current-page.sync="page.pageNo"
      :page-sizes="$pageSizeAll"
      :page-size.sync="page.pageSize"
      layout="total, sizes, prev, pager, next"
      :total="page.pageTotal"
    ></el-pagination>
    <!-- pagigation end -->
  </el-card>
</template>

<script>
import { ApplyApplicationApi, OpenApiApi } from '@wiz-api/open-api-management'

const applyApplicationApi = new ApplyApplicationApi()
const openApiApi = new OpenApiApi()
export default {
  name: 'apiApply',
  components: {},
  data() {
    return {
      organizationList: [],
      tableLoading: true,
      apiTypes: [],
      tableData: [],
      apiMethods: [], // api请求方式
      searchCondition: {
        keyword: '',
        type: '',
        audit_state: '',
        name: '',
        department_id: '',
      },
      page: {
        pageNo: 1,
        pageSize: 15,
        pageTotal: 0,
      },
      auditStutusList: [],
      selectList: [],
      submitLoading: false,
      withdrawLoading: false,
    }
  },
  computed: {
    tableHeight() {
      return `${window.innerHeight - 220}px`
    },
  },
  methods: {
    selectionChange(val) {
      this.selectList = _.map(val, (item) => {
        return item.applyOpenApiRecordId
      })
    },
    // 批量提交
    async submit() {
      this.submitLoading = true
      const [err, res] = await applyApplicationApi.submitApplyOpenApi({
        body: this.selectList,
      })
      this.submitLoading = false
      if (!err) {
        this.$message.success('提交成功')
        this.findTableData()
        this.selectList = []
        this.$nextTick(() => {
          this.$refs.table.clearSelection()
        })
      }
    },
    // 批量撤回
    async withdraw() {
      this.withdrawLoading = true
      const [err, res] = await applyApplicationApi.cancelSubmitApplyOpenApi({
        body: this.selectList,
      })
      this.withdrawLoading = false
      if (!err) {
        this.$message.success('撤回成功')
        this.findTableData()
        this.selectList = []
        this.$nextTick(() => {
          this.$refs.table.clearSelection()
        })
      }
    },
    async getAuditStatus() {
      const [err, res] = await applyApplicationApi.getAuditStatus({ isContainNotSubmitStatus: 1 })
      if (!err) {
        this.auditStutusList = _.map(res, (item) => {
          return {
            label: item.item2,
            value: item.item1,
          }
        })
      }
    },
    computeOrganization(name) {
      const currentRow = _.find(this.organizationList, ['id', name])
      return currentRow ? currentRow.name : name
    },
    handleRow(row, type) {
      if (type === 'submit' || type === 'reset') {
        const text = type === 'submit' ? '提交' : '撤回'
        this.$confirm(`确认要${text}么?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            if (type === 'submit') {
              const [err, res] = await applyApplicationApi.submitApplyOpenApi({
                body: [row.applyOpenApiRecordId],
              })
              if (!err) {
                this.$message.success('提交成功')
                this.findTableData()
              }
            } else if (type === 'reset') {
              const [err, res] = await applyApplicationApi.cancelSubmitApplyOpenApi({
                body: [row.applyOpenApiRecordId],
              })
              if (!err) {
                this.$message.success('撤回成功')
                this.findTableData()
              }
            }
          })
          .catch(() => {
            this.$message.info('取消提交')
          })
        return
      }
      if (type === 'edit' || type === 'read') {
        this.$router.push(`./api-apply?id=${row.applyApplicationId}&type=${type}`)
      }
    },
    deleteRow(row) {
      this.$confirm('是否确定要删除该条数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          this.tableLoading = true
          const [err, res] = await applyApplicationApi.deleteApplyOpenApiRecords(
            row.applyOpenApiRecordId
          )
          this.tableLoading = false
          if (!err) {
            this.$message.success('删除成功')
            if (this.tableData.length === 1 && this.page.pageNo > 1) {
              this.page.pageNo -= 1
              this.findTableData()
              return
            }
            this.findTableData()
          }
        })
        .catch(() => {
          this.$message.info('取消删除')
        })
    },
    async findApiType() {
      const [err, res] = await openApiApi.getDistinctApiType()
      if (!err) {
        this.apiTypes = _.map(res, (item) => {
          return {
            label: item,
            value: item,
          }
        })
      }
    },
    searchTableData() {
      this.page.pageNo = 1
      this.findTableData()
    },
    async findTableData() {
      const reqData = {
        skipCount: this.page.pageNo,
        maxResultCount: this.page.pageSize,
        sorting: '',
        keywords: this.searchCondition.keyword,
        apiType: this.searchCondition.type,
        auditStatus: this.searchCondition.audit_state,
        name: this.searchCondition.name,
        department: this.searchCondition.department_id,
        isQueryNotSubmittedRecord: 1, // 是否查询未提交记录，0=不查询，1=查询
      }
      this.tableLoading = true
      const [err, res] = await applyApplicationApi.getApplyOpenApiRecordPagedResult(reqData)
      this.tableLoading = false
      if (!err) {
        this.tableData = res.items
        this.page.pageTotal = res.totalCount
        _.forEach(this.tableData, (item) => {
          item.state = item.state === 0 // 0 启用 1 停用
        })
      }
    },
  },
  async created() {
    this.organizationList = await localforage.getItem('organizationList')
    this.findApiType()
    this.getAuditStatus()
    this.searchTableData()
  },
  mounted() {},
}
</script>

<style lang="scss" scoped>

/deep/ .el-form-item {
  margin-bottom: 0px !important;
}

</style>
